export default {
  _not_interested_in_this_video: 'Не заинтересованы в этом видео? %second%',
  _switch_one: 'еще один',
}